import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { utils } from 'kb-shared';
import Cache from '@aws-amplify/cache';
import Honeybadger from '@honeybadger-io/js';

import * as redux from '../redux';
import AppleDisclaimerModal from './AppleDisclaimerModal';

const { REACT_APP_APPLE_CLIENT_ID, REACT_APP_APPLE_REDIRECT_URL } = process.env;

const { signInAppleUser } = redux.patient;
const { decodeJwtPayload } = utils;
interface AppleAuthJsonPayload {
  auth_time: number;
  email: string;
  email_verified: string;
  exp: number;
  iat: number;
  iss: string;
}

const AppleButton = styled.button`
  appearance: none;
  -webkit-appearance: none;
  border: none;
  background: #000000;
  font-size: 16px;
  cursor: pointer;
  border-radius: 7px;
  color: white;
  width: 240px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 16px;
`;

const ButtonText = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
`;

const ButtonIcon = styled.span`
  font-size: 18px;
  margin-right: 44px;
`;

interface Props {
  operation: 'login' | 'signUp';
}

const AppleAuthButton = (props: Props) => {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);

  window.AppleID.auth.init({
    clientId: REACT_APP_APPLE_CLIENT_ID, // This is the service ID we created.
    scope: 'name email', // To tell apple we want the user name and emails fields in the response it sends us.
    redirectURI: REACT_APP_APPLE_REDIRECT_URL, // As registered along with our service ID
    state: 'origin:web', // Any string of your choice that you may use for some logic. It's optional and you may omit it.
    usePopup: true // Important if we want to capture the data apple sends on the client side.
  });

  const singInApple = async () => {
    try {
      const { authorization } = await window.AppleID.auth.signIn();
      await Cache.setItem('@AppleSSO:idToken', authorization.id_token as string);
      const jsonPayload = decodeJwtPayload(authorization.id_token);
      dispatch(signInAppleUser(authorization.id_token, jsonPayload.email, props.operation));
    } catch (error) {
      Honeybadger.notify(error);
    }
  };

  const handleClick = () => {
    if (props.operation == 'login') {
      return singInApple();
    }

    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    singInApple();
  };

  return (
    <>
      <AppleButton onClick={handleClick} type="button">
        <ButtonIcon></ButtonIcon>
        <ButtonText>{props.operation === 'signUp' ? 'Sign up' : 'Log in'} with Apple</ButtonText>
      </AppleButton>
      <AppleDisclaimerModal showModal={showModal} handleClose={handleModalClose} />
    </>
  );
};

export default AppleAuthButton;
